<script>
    export let fill = "#fff";
    export let size = 20;
</script>

<svg
   xmlns:dc="http://purl.org/dc/elements/1.1/"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns="http://www.w3.org/2000/svg"
   data-name="Layer 1"
   viewBox="0 0 28.636639 28.657677"
   x="0px"
   y="0px"
   version="1.1"
   id="svg8"
   width="{size}"
   height="{size}"
   fill="{fill}"
>
  <defs id="defs12" />
  <path
    id="path2"
     d="m 17.85654,1.462318 a 5.016,5.016 0 0 0 -7.08,0 l -9.3399999,9.34 a 5.08,5.08 0 0 0 0,7.08 l 9.3399999,9.34 a 5.083,5.083 0 0 0 7.08,0 l 9.34,-9.34 a 5.071,5.071 0 0 0 0,-7.08 z m 2.382,12.261 a 0.93,0.93 0 0 1 -0.212,0.329 l -3,3 a 1.03,1.03 0 0 1 -1.42,0 1.008,1.008 0 0 1 0,-1.42 l 1.3,-1.29 h -4.59 v 4 a 1,1 0 0 1 -2,0 v -5 a 1,1 0 0 1 1,-1 h 5.59 l -1.3,-1.29 a 1.0040916,1.0040916 0 0 1 1.42,-1.42 l 3,3 a 1.044,1.044 0 0 1 0.212,1.091 z"
  />
</svg>